var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectable)?_c('div',{class:_vm.cellClasses},[(_vm.flagged)?_c('ClockIcon',{staticClass:"Cell-icon clock-icon"}):_vm._e()],1):_c('div',{class:_vm.cellClasses},[_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }